import request1 from './request1';

class RequestImpl {
  init(requestParam) {
    this.requestParam = requestParam;
  }
  start() {
    const { path, serviceName, method, dataType, responseType, header, requestParams, data, login } = this.requestParam;
    const url = `/api/${serviceName}/${path}`;
    return request1(url, {
      method,
      body: data,
      login,
    });
  }
}

export default RequestImpl;
